const LANGUAGE_KEY = "gatsby-i18next-language"
/** Set only when the user picks a language in the UI switcher. */
const EXPLICIT_LANGUAGE_KEY = "dim-language-explicit"
const SUPPORTED = ["en", "es"]
const DEFAULT_LANGUAGE = "en"

/**
 * Browser UI / primary language only (`navigator.language`).
 * Spanish → "es". Anything else (en, fr, de, ca, …) → "en".
 */
export const detectSiteLanguage = () => {
  if (typeof navigator === "undefined") {
    return DEFAULT_LANGUAGE
  }

  const raw = navigator.language || navigator.userLanguage || ""
  const code = String(raw).toLowerCase().split(/[-_]/)[0]
  return code === "es" ? "es" : DEFAULT_LANGUAGE
}

export const getExplicitSiteLanguage = () => {
  if (typeof window === "undefined") {
    return null
  }
  try {
    const stored = window.localStorage.getItem(EXPLICIT_LANGUAGE_KEY)
    return SUPPORTED.includes(stored) ? stored : null
  } catch {
    return null
  }
}

/** Persist a manual language choice from the navbar switcher. */
export const setExplicitSiteLanguage = language => {
  if (typeof window === "undefined" || !SUPPORTED.includes(language)) {
    return
  }
  try {
    window.localStorage.setItem(EXPLICIT_LANGUAGE_KEY, language)
    window.localStorage.setItem(LANGUAGE_KEY, language)
  } catch {
    // ignore quota / private mode errors
  }
}

export const setStoredSiteLanguage = language => {
  if (typeof window === "undefined" || !SUPPORTED.includes(language)) {
    return
  }
  try {
    window.localStorage.setItem(LANGUAGE_KEY, language)
  } catch {
    // ignore
  }
}

export {
  LANGUAGE_KEY,
  EXPLICIT_LANGUAGE_KEY,
  DEFAULT_LANGUAGE,
  SUPPORTED,
}
